module.exports = __webpack_public_path__ + "static/media/corner.fd1f905b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/corner.svg
// module id = 471
// module chunks = 7